// extracted by mini-css-extract-plugin
module.exports = {"container":"mainPlanets_container__3vJo2","insta":"mainPlanets_insta__37XRy","copyArea":"mainPlanets_copyArea__1Xl8t","closeBtn":"mainPlanets_closeBtn__3hwhu"};